import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ChatList from "../../Components/Host/Dashboard/ChatList";
import ChatWindow from "../../Components/Host/Dashboard/ChatWindow";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function UserMessage() {
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");
  const [selectedChat, setSelectedChat] = useState(null);
  const [baseURL, setBaseURL] = useState(null);
const [meta,setMeta] = useState();
  const [isChatOpen, setIsChatOpen] = useState(false);


  const location = useLocation();
  const chatTarget = useMemo(
    () => location?.state?.chatTarget || null,
    [location?.state]
  );

  const API_BASE = process.env.REACT_APP_API_BASE;

  // --- fetch chats (unchanged, just extracted as a callback so we can reuse) ---
  const fetchChats = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/user/chat-hosts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setChatList(res.data?.data || []);
      setBaseURL(res.data?.base_url || null);
    } catch (err) {
      console.error("Error fetching chat list", err);
      setChatList([]);
    } finally {
      setLoading(false);
    }
  }, [API_BASE, token]);

  useEffect(() => {
    fetchChats();
  }, [fetchChats]);

  // --- ensure/select target without creating any local temp rows in the list ---
  const isEnsuringRef = useRef(false);
  const ensureChatWithTarget = useCallback(async () => {
    if (!chatTarget || loading || isEnsuringRef.current) return;
    isEnsuringRef.current = true;

    try {
      // 1) Try to find in the server list
      const existing = chatList.find(
        (c) => Number(c.user_id) === Number(chatTarget.user_id)
      );
      if (existing) {
        setSelectedChat(existing);
        return;
      }

      // 2) Not found → select a minimal "pending" selection ONLY (not added to chatList)
      const pendingSelection = {
        user_id: chatTarget.user_id,
        first_name: chatTarget.first_name || "",
        last_name: chatTarget.last_name || "",
        email: chatTarget.email || "",
        // normalize to profile_pic to satisfy ChatWindow/ChatList
        profile_pic: chatTarget.profile_image || chatTarget.profile_pic || null,
        last_message: "",
        last_message_time: null,
        unread_count: 0,
      };
      setSelectedChat(pendingSelection);
    } finally {
      isEnsuringRef.current = false;
    }
  }, [chatTarget, loading, chatList]);

  useEffect(() => {
    ensureChatWithTarget();
  }, [ensureChatWithTarget]);

  // --- called AFTER the first successful send, to refresh and then select the real thread ---
  const handleChatCreated = useCallback(
    async ({ user_id }) => {
      await fetchChats();

      // small retry if backend is eventually consistent
      let found = (lst) => lst.find((c) => Number(c.user_id) === Number(user_id));
      let selected = found(window.__lastChatList__ || chatList);

      if (!selected) {
        // one light retry after 400ms
        await new Promise((r) => setTimeout(r, 400));
        await fetchChats();
        selected = found(window.__lastChatList__ || chatList);
      }

      if (selected) setSelectedChat(selected);
    },
    [fetchChats, chatList]
  );

  // keep a mirror for the retry finder above
  useEffect(() => {
    if (typeof window !== "undefined") window.__lastChatList__ = chatList;
  }, [chatList]);

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
  ensureChatWithTarget();

  // 👇 If there’s a target and user is on mobile, open chat window directly
  if (chatTarget && window.innerWidth <= 768) {
    setIsChatOpen(true);
  }
}, [ensureChatWithTarget, chatTarget]);


  const handleSelectChat = (chat) => {
  setSelectedChat(chat);
  setIsChatOpen(true); // show chat window on mobile
};

 useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("chat");
      setMeta(data);
    };

    loadMeta();
  }, []);


  return (
    <section className="messagechats user_allls us_messages">
        <SetMetaTags
        title= {meta?.meta_title || "Chat | Weyfarin"}
        description={meta?.meta_description || "Chat | Weyfarin"}
      
      />

      <div className="bedcramss">
        <Link to="/profile">Dashboard</Link> &gt; Message
      </div>

      {/* <div className="msg_chats_main"> */}
      <div className={`msg_chats_main ${isChatOpen ? "chat-open" : ""}`}>
  <div className={`chat-list-wrapper ${isChatOpen ? "hide-mobile" : "show-mobile"}`}>
        <ChatList
          chats={chatList}
          loading={loading}
          // onSelectChat={setSelectedChat}
          onSelectChat={handleSelectChat}
          baseUrl={baseURL}
          selectedChat={selectedChat}
           
        />
        </div>
<div className={`chat-window-wrapper ${isChatOpen ? "show-mobile" : "hide-mobile"}`}>
        <ChatWindow
          selectedChat={selectedChat}
          baseUrl={baseURL}
          onChatCreated={handleChatCreated}  
          onBack={() => setIsChatOpen(false)} // 👈 back to list
        />
        </div>
      </div>
    </section>
  );
}

export default UserMessage;

